import { isEqual } from 'lodash';

import { FullProfile } from '../model/types';

export function keysOf<T extends object>(obj: T): Array<keyof T> {
    return Object.keys(obj) as Array<keyof T>;
}

export function getChangedProfileValues(chagedValues: Partial<FullProfile>, originalValues?: FullProfile) {
    if (!originalValues) {
        return Object.keys(chagedValues);
    }

    return keysOf(chagedValues).reduce(
        (acc, key) => (!isEqual(originalValues[key], chagedValues[key]) ? [...acc, key] : acc),
        [] as string[]
    );
}
